
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeleteTeamConfirm',
  props: {
    teamName: {
      type: String,
      required: true
    },
    deletingTeam: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deleteStep: 0,
      typedTeamName: ''
    }
  },
  methods: {
    /**
     * Handles the delete modal close event. Makes sure that the delete processes resets completely.
     *
     * @returns {void}
     */
    handleDialogClose(): void {
      this.deleteStep = 0
      this.$emit('close')
    }
  }
})
